import { Button } from '@upmc/ims.component-library';
import styles from './CreateEventButton.module.scss';
import { useState } from 'react';

import { CreateAppNotification } from '../../../_api';
const CreateEventButton = ({
	eventType,
	appID,
	currentUser,
	setAppNotifications,
	disabled,
	requirementNumber,
}) => {
	const [isLoading, setIsLoading] = useState(false);

	const createEvent = () => {
		if (
			window.confirm(
				'Are You sure you want to create this event? A record will be inserted into TS_Event_Matrix table and can not be undone.'
			)
		) {
			setIsLoading(true);
			CreateAppNotification({
				eventTypeID: eventType.eventTypeID,
				actionID: eventType.actionID,
				appID: appID,
				user: currentUser.NetworkID,
				requirementNumber: requirementNumber,
			}).then(resp => {
				setAppNotifications(resp.notificationEvents);
				setIsLoading(false);
			});
		}
	};

	//TODO: implement a loading spinner while the api call resolves. then set the appManagement model to the one returned from the CreateAppNotification api call to update the controls to then allow a user to add recipients for the newly created notification, as well as debug any issues with the api call

	return (
		<>
			<Button
				className={styles.button}
				onClick={() => createEvent()}
				disabled={isLoading || disabled}
				id='create_event_btn'
			>
				Create Event
			</Button>
		</>
	);
};

export default CreateEventButton;
